/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': '未命名页面',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': '创建一个新页面并将其作为链接插入',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': '创建 Confluence 页面',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': '在 Confluence 中打开',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': '您的页面已创建',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': '页面已创建',
  'editorExtensionLinkCreate.confluencePage.title': '创建新页面',
  'editorExtensionLinkCreate.genericError.description': '请刷新页面并重试。',
  'editorExtensionLinkCreate.genericError.title': '出错了',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description': '以内联方式创建一个事务并将该事务作为链接插入',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': '在 Jira 中创建事务',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': '在 Jira 中打开',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': '您的事务已创建',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': '事务已创建',
  'editorExtensionLinkCreate.jiraIssue.title': '创建新事务',
  'editorExtensionLinkCreate.keyword.create': '创建',
  'editorExtensionLinkCreate.keyword.issue': '事务',
  'editorExtensionLinkCreate.keyword.new': '新建',
  'editorExtensionLinkCreate.keyword.page': '页面',
  'editorExtensionLinkCreate.keyword.publish': '发布',
  'editorExtensionLinkCreate.keyword.raise': '提起',
  'editorExtensionLinkCreate.keyword.space': '空间',
  'editorExtensionLinkCreate.keyword.ticket': '工作单',
};
